import { atom } from 'jotai';

export const showClaimsBanner = atom(false);
